import { IAppState } from '@myStore/app.state';
import { IPeriodsViewState } from '@myStore/periods-view/periods-view.state';
import { createSelector } from '@ngrx/store';

const periodsViewSelector = (state: IAppState) => state.periodsView;

export const selectPeriod = createSelector(
  periodsViewSelector,
  (state: IPeriodsViewState) => state?.period.data
);

export const selectPeriodLoading = createSelector(
  periodsViewSelector,
  (state: IPeriodsViewState) => state?.period.isLoading
);

export const selectGroupPeriodsList = createSelector(
  periodsViewSelector,
  (state: IPeriodsViewState) => state?.periods
);

export const selectGroupPeriodsListLoading = createSelector(
  periodsViewSelector,
  (state: IPeriodsViewState) => state?.isLoading
);
